<template>
    <div>

        <div>
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">角色管理</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

                    <el-row style="padding-left: 46px; padding-top: 40px;">

                        <el-col :span="4">
                            <span>角色名称</span>
                            <el-input v-model="condition.role_name" placeholder="请输入角色名称"
                                style="width: 65%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="8">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                                @click="Find">
                                查询</el-button>
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                                @click="Del(null)">
                                删除</el-button>
                            <el-button style="width: 85px; border: 1px solid #006E4B; color: #006E4B;" @click="AddFrom">
                                新增</el-button>
                        </el-col>

                    </el-row>

                    <el-row style="margin: 0px 2%; margin-top: 10px;">
                        <el-row>
                            <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                                :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="540"
                                tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55">
                                </el-table-column>
                                <el-table-column align="center" label="序号">
                                    <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                                </el-table-column>
                                <el-table-column prop="role_name" align="center" label="角色"></el-table-column>
                                <el-table-column prop="create_time" align="center" label="生成时间"></el-table-column>
                                <el-table-column align="center" label="操作">
                                    <template slot-scope="scope">
                                        <img src="../../../assets/权限.png" @click="SetPermission(scope.row)">
                                        <img src="../../../assets/岗位.png" @click="Post(scope.row)">
                                        <img src="../../../assets/编辑.png" @click="UpdateFrom(scope.row)"
                                        style="margin-left: 10px">
                                        <img src="../../../assets/删除.png" @click="Del(scope.row.id)"
                                            style="margin-left: 10px" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                        <el-row style="margin-top: 10px; text-align: center;">
                            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                                layout=" prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </el-row>
                    </el-row>
                </div>
            </el-row>
        </div>
        

        <div>
            <el-dialog :title="from.id == null || from.id == '' ? '添加角色' : '修改角色'" :visible.sync="dialogVisible"
                width="30%" :close-on-click-modal="false" :center="true">
                
                <el-form :model="from" :rules="rules" ref="from" style="padding: 0 10%;" label-width="100px">
                    <el-form-item label="角色" prop="role_name">
                        <el-input v-model="from.role_name" placeholder="请输入角色名称" style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item style="text-align: center;" label-width="0px">
                        <el-button type="primary" @click="Add" v-show="from.id == null || from.id == ''"
                            style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
                        <el-button type="primary" @click="Update" v-show="from.id != null && from.id != ''"
                            style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">修改</el-button>
                    </el-form-item>
                </el-form>
                
            </el-dialog>
            
            <el-dialog title="权限设置" :visible.sync="eidtRedirection"
                width="30%" :close-on-click-modal="false" :center="true">
                <div style="width: 100%;height:300px;overflow-x: hidden;">
                    <el-checkbox-group v-model="checkList">
                        <div v-for="(item,index) in JurisdictionList" :key="index" style="font-size:20px;">
                            <div style="text-align: center">{{item.jurisdiction_grouping}}</div>
                                <div style="margin-left:15%;font-size:15px;padding:20px">
                                    <el-checkbox v-for="(sysJurisdiction,sysJurisdictionIndex) in item.sysJurisdictionList"
                                        :key="sysJurisdictionIndex" :label="sysJurisdiction.id"  style="width:40%"> {{sysJurisdiction.jurisdiction_name}}
                                    </el-checkbox>
                                </div>
                        </div>  
                    </el-checkbox-group>             
                </div>
                <el-button round style="background-color:#006E4B;color:#fff;margin-left:40%;margin-top:20px" @click="Jurisdictionsave()">确定</el-button>
            </el-dialog>

            <el-dialog title="选择岗位" :visible.sync="eidtPost"
                width="30%" :close-on-click-modal="false" :center="true">
                <div style="width: 100%;height:300px;overflow-x: hidden;">
                    <el-checkbox-group v-model="gwList">
                                <div style="margin-left:10%;font-size:15px;padding:10px;">
                            <el-checkbox v-for="(postitem,index) in postList" :key="index" :label="postitem.id" style="width:42%">
                                 {{postitem.post_name}}
                            </el-checkbox>
                        </div>
                        
                    </el-checkbox-group>             
                </div>
                <el-button round style="background-color:#006E4B;color:#fff;margin-left:40%;margin-top:20px" @click="postsave()">确定</el-button>
            </el-dialog>
        </div>

    </div>
</template>

<script>

    import axios from "axios";
    export default {
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //页面相关
                dialogVisible: false,
                eidtRedirection: false,
                eidtPost:false,

                //条件
                condition: {
                    role_name: "",
                },

                //详情
                from: {
                    id: "",
                    role_name: "",
                },

                sysJurisdictionList:[],
                JurisdictionList:[],
                jurisdiction_ids:[],

                checkList:[],
                postList:[],
                gwList:[],

                //复选框ids
                ids: [],
                
                //表单验证
                rules: {
                  role_name: [{
                    required: true,
                    message: '请输入角色名称！',
                    trigger: 'blur'
                  }],
                }
            };
        },
        methods: {
            //返回
            Return(e) {
                if(e === 'add'){
                    this.dialogVisible = false;
                }else{
                    this.eidtRedirection = false;
                }
                this.Find();
            },
            //列表点击复选框
            // handleSelectionChange(e) {
            //     this.ids = [];
            //     e.forEach(item => {
            //         this.ids.push(item.id);
            //     })
            // },
            //查询
            Find() {
                const url = this.$globals.http + "role/find";
                axios.post(url, {
                    page_num: this.page_num,
                    page_size: this.page_size,
                    role_name: this.condition.role_name,
                }).then((response) => {
                    var code = response.data.code;
                    var data = response.data.data;

                    if (code === '200') {

                        this.tableData = data.list;
                        this.total = data.total;

                    } else {
                        this.$message.warning("请求失败！请稍后重试");
                    }
                }).catch((error) => {
                    console.log(error)
                    this.$message.error("服务器未响应！请稍后重试");
                })
            },
			//分页查询
			handleCurrentChange(e){
				this.page_num = e;
				this.Find();
			},
            //新增页面
            AddFrom() {
                this.trash();
                this.dialogVisible = true;
            },
            //添加操作
            Add() {
                this.$refs["from"].validate((valid) => {
                    if (valid) {
                
                        const url = this.$globals.http + "role/add";
                        axios.post(url, {
                            role_name: this.from.role_name,
                        }).then((response) => {
                            var code = response.data.code;
                            var data = response.data.data;
                
                            if (code === '200') {
                
                                this.$message.success(data);
                                this.Return("add");
                
                            } else {
                                this.$message.warning("请求失败！请稍后重试");
                            }
                        }).catch((error) => {
                            console.log(error)
                            this.$message.error("服务器未响应！请稍后重试");
                        })
                
                    }
                });
            },
            //编辑页面
            UpdateFrom(e) {
                this.from.id = e.id;
                this.from.role_name = e.role_name;
                this.dialogVisible = true;
            },
            //编辑操作
            Update() {
                this.$refs["from"].validate((valid) => {
                    if (valid) {
                            
                        const url = this.$globals.http + "role/modify";
                        axios.post(url, {
                            id: this.from.id,
                            role_name: this.from.role_name,
                        }).then((response) => {
                            var code = response.data.code;
                            var data = response.data.data;
                            
                            if (code === '200') {
                            
                                this.$message.success(data);
                                this.Return("add");
                            
                            } else {
                                this.$message.warning("请求失败！请稍后重试");
                            }
                        }).catch((error) => {
                            console.log(error)
                            this.$message.error("服务器未响应！请稍后重试");
                        })
                            
                    }
                });
            },
            //修改权限页面
            SetPermission(e) {
                this.checkList=[];
                this.from.id = e.id;
                this.eidtRedirection = true;
                this.Jurisdiction();
                if(e.jurisdiction_ids == null || e.jurisdiction_ids == '' ){
                    this.checkList=[];
                }else{
                    this.checkList = e.jurisdiction_ids;
                }
                
            },
            
            async Jurisdiction() {
                var res = await this.$globals.AxiosPost("Jurisdiction/All",{});
                this.JurisdictionList = res.data;
            },
            //修改角色权限
            async Jurisdictionsave() {
				var url = "/JurisdictionRole/updateJurisdictionRole";
				var record = {
                    role_id : this.from.id,
                    jurisdiction_ids : this.checkList,
				};
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.checkList=[];
                        this.Find();
                        this.eidtRedirection = false;
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            // 选择岗位
            Post(e){
                this.gwList=[];
                this.from.id = e.id;
                this.eidtPost = true;
                if(e.role_post == null || e.role_post == '' ){
                    this.gwList=[];
                }else{
                    this.gwList = e.role_post;
                }
                this.posts();
            },
            async posts() {
                var res = await this.$globals.AxiosPost("/post/finds",{});
                this.postList = res.data;
            },
            async postsave(){
                var url = "/role/updateRole";
                var record = {
                    id : this.from.id,
                    role_post : this.gwList,
                };
                 var data = await this.$globals.AxiosPost(url, record);
                 if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.gwList=[];
                        this.Find();
                        this.eidtPost = false;
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            //删除
            Del(e) {
                var ids;
                if (e === null || e === "" || e === undefined) {
                    if (this.ids === null || this.ids.length <= 0) {
                        this.$message.warning("请先选择操作数据！");
                        return false;
                    }
                    ids = this.ids;
                } else {
                    ids = [e];
                }

                const url = this.$globals.http + "role/del";
                axios.post(url, {
                    ids: ids,
                }).then((response) => {
                    var code = response.data.code;
                    var data = response.data.data;

                    if (code === '200') {

                        this.$message.success(data);
                        this.Find();

                    } else {
                        this.$message.warning("请求失败！请稍后重试");
                    }
                }).catch((error) => {
                    console.log(error)
                    this.$message.error("服务器未响应！请稍后重试");
                })
            },
            //清除数据
            trash() {
                this.from.role_name = "";
                this.from.id = "";
            }
        },
        created() {
            this.Find();
            
        }
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-checkbox__inner:hover {
        border-color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// Role.vue?270b5ce2